module.exports = __webpack_public_path__ + "img/seminarscore.37e65a0f.jpeg";